import { jsx, jsxs } from "react/jsx-runtime";
import { c } from "react-compiler-runtime";
import { useTheme } from "@mui/material/styles";
const GenderIcon = (props)=>{
    const $ = c(13);
    const theme = useTheme();
    let t0;
    if ($[0] !== theme.tokens.colors.bg.greyscale.primary) {
        t0 = /*#__PURE__*/ jsx("rect", {
            width: "48",
            height: "48",
            rx: "24",
            fill: theme.tokens.colors.bg.greyscale.primary
        });
        $[0] = theme.tokens.colors.bg.greyscale.primary;
        $[1] = t0;
    } else t0 = $[1];
    let t1;
    let t2;
    let t3;
    if ($[2] !== theme.tokens.colors.stroke.tertirary) {
        t1 = /*#__PURE__*/ jsx("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M16.9289 16.9289C18.7376 15.1203 21.2388 14 24 14C26.7612 14 29.2624 15.1203 31.0711 16.9289C32.8797 18.7376 34 21.2388 34 24C34 26.7612 32.8797 29.2624 31.0711 31.0711C29.2624 32.8797 26.7612 34 24 34C21.2388 34 18.7376 32.8797 16.9289 31.0711C15.1203 29.2624 14 26.7612 14 24C14 21.2388 15.1203 18.7376 16.9289 16.9289ZM24 15.8C21.7354 15.8 19.6866 16.7168 18.2017 18.2017C16.7168 19.6866 15.8 21.7354 15.8 24C15.8 26.2646 16.7168 28.3134 18.2017 29.7983C19.6866 31.2832 21.7354 32.2 24 32.2C26.2646 32.2 28.3134 31.2832 29.7983 29.7983C31.2832 28.3134 32.2 26.2646 32.2 24C32.2 21.7354 31.2832 19.6866 29.7983 18.2017C28.3134 16.7168 26.2646 15.8 24 15.8Z",
            fill: theme.tokens.colors.stroke.tertirary
        });
        t2 = /*#__PURE__*/ jsx("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M23.2317 20.0905C22.9782 20.2851 22.8231 20.5239 22.7716 20.7243C22.6477 21.2057 22.157 21.4955 21.6756 21.3716C21.1943 21.2477 20.9045 20.757 21.0284 20.2757C21.1988 19.6134 21.6279 19.0523 22.1359 18.6625C22.6454 18.2715 23.3028 18 24 18C25.6016 18 27 19.3984 27 21C27 22.3706 26.2497 23.2208 25.7146 23.8068C25.1162 24.4623 24.9 24.7177 24.9 25.1C24.9 25.5971 24.497 26 24 26C23.5029 26 23.1 25.5971 23.1 25.1C23.1 23.977 23.8092 23.2138 24.2737 22.714C24.3128 22.6719 24.3502 22.6316 24.3853 22.5932C24.9003 22.0292 25.2 21.6294 25.2 21C25.2 20.3925 24.6075 19.8 24 19.8C23.7652 19.8 23.4837 19.8971 23.2317 20.0905Z",
            fill: theme.tokens.colors.stroke.tertirary
        });
        t3 = /*#__PURE__*/ jsx("path", {
            d: "M25.2 28.6C25.2 29.2627 24.6627 29.8 24 29.8C23.3372 29.8 22.8 29.2627 22.8 28.6C22.8 27.9373 23.3372 27.4 24 27.4C24.6627 27.4 25.2 27.9373 25.2 28.6Z",
            fill: theme.tokens.colors.stroke.tertirary
        });
        $[2] = theme.tokens.colors.stroke.tertirary;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
    } else {
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
    }
    let t4;
    if ($[6] !== props.height || $[7] !== props.width || $[8] !== t0 || $[9] !== t1 || $[10] !== t2 || $[11] !== t3) {
        t4 = /*#__PURE__*/ jsxs("svg", {
            width: props.width,
            height: props.height,
            viewBox: "0 0 48 48",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            fontSize: "inherit",
            children: [
                t0,
                t1,
                t2,
                t3
            ]
        });
        $[6] = props.height;
        $[7] = props.width;
        $[8] = t0;
        $[9] = t1;
        $[10] = t2;
        $[11] = t3;
        $[12] = t4;
    } else t4 = $[12];
    return t4;
};
export { GenderIcon };
